/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { autobind } from '../../packages/core/lib';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    TranslationID
} from '../../packages/components';
import './_styles.scss';
import { connect } from 'react-redux';
import Assets from '../../requests/apa/Asset';
import { PTV, REGISTER_INPUT_STYLE_OUTFOCUS } from '../utils/constants';
import Translator from '../../requests/apa/Translator';
import { showModal, AAF_MODAL_SUCCESS_PTV_SHORT } from '../../actions/modal';
import { ColoredButton } from '../../packages/components/lib/ColoredButton/';
import Device from '../../devices/device';
import { regExp } from 'packages/components/lib/Input/utils';
import {
    cleanUserPtvUrl,
    fetchAuthDeviceEmailRegistration
} from '../../reducers/user';
import Utils, {setInitialFocus} from '../../utils/Utils';
import { IP_TV, COMPONENTE_IP_TV} from '../utils/constansMetrics';
import { setMetricsEvent } from '../../actions/metrics';


enum Steps {
    STEP_MAIL = 'INSERT_MAIL',
}

interface IProps {
    passwordReminder: { [key: string]: string };
}

interface IStepsValue {
    [key: string]: string | undefined;
    title: string;
    subtitle: string;
    placeholder: string;
    next?: string;
    cancel?: string;
}

interface ILoginState {
    step: string;
    email: string;
    valid: boolean;
    errorFromBackend: string;
}

class Ptv extends Component<RouteComponentProps & IProps, ILoginState> {
    public headerLogo: string = Assets.get('logo_clarotv') || '';
    public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
    private account: string = '';
    private isValidForm:boolean;

    private  translations : Record<TranslationID, string> = {
        'password_tooltip_completeField': Translator.get('password_tooltip_completeField_label_validation','Debes completar este campo'),
        'email_tooltip_valid': Translator.get('email_tooltip_valid_label_validation','Ingresa un correo electrónico válido.'),
    } as const;

    constructor(props: RouteComponentProps & IProps) {
        super(props);
        this.state = { 
            step: Steps.STEP_MAIL, 
            email: '', 
            valid: false,
            errorFromBackend: ''
        };
        this.isValidForm = false;
    }

    private handleSubmit = (email: string): void => {
        let extraParams = {};
        if(this.props.user && this.props.user.ptv_url){
            const params =  Utils.urlParamsToJson(this.props.user.ptv_url);
            if(params && typeof params === 'object'){
                extraParams = params;
            }
        }

        this.props.fetchAuthDeviceEmailRegistration(email, this.account, {...extraParams}).then((response: any) => {
            const modal = {
                modalType: AAF_MODAL_SUCCESS_PTV_SHORT,
                modalProps: {
                    callback: () => {
                        this.props.history.push('/');
                    },
                    email: email
                }
            };
            this.props.showModal(modal);
        }).catch((error: any) => {
            this.setState({ valid: false, errorFromBackend:  error.code ? Translator.get(error.code.trim(), '') : error.message});
        });
    };

    private handleChange = (event: string): void => {
        let { email, valid } = this.state;

        this.isValidForm = event !== '';

        if (regExp.validEmail.test(event)) {
            valid = true;
        } else {
            valid = false;
        }
        email = event;
        this.setState({ email, valid, errorFromBackend: ''  });
    };

    private handleCancel = (): void => {
        const { step } = this.state;
        Utils.sendMetric(this.props, IP_TV,  IP_TV , COMPONENTE_IP_TV);
        switch (step) {
            case Steps.STEP_MAIL:
                this.handleSkip();
                break;
            default:
                break;
        }
    };

    private handleSkip = (): void => {
        this.props.cleanUserPtvUrl();
        let email = '';
        if(this.account){
            email =`${this.account}@cv.com`;
        }else if(this.props.user.email){
            email = this.props.user.email;
        }
        this.handleSubmit(email);
    };

    private handleNextStep = (): void => {
        const { step } = this.state;
        let { email } = this.state;
        Utils.sendMetric(this.props, IP_TV,  IP_TV , COMPONENTE_IP_TV);

        if (email === undefined || email === '') {
            this.setState({ valid: false, errorFromBackend: this.translations['password_tooltip_completeField']});
            return;
          } else
    
          if(!regExp.validEmail.test(email)) {
            this.setState({ valid: false, errorFromBackend: this.translations['email_tooltip_valid']});
          }

        switch (step) {
            case Steps.STEP_MAIL:
                if (regExp.validEmail.test(email)) {
                    this.isValidForm = true;
                    this.handleSubmit(email);
                }
                break;
            default:
                break;
        }
    };

    private getTextBySteps = (attribute: string): string => {
        const result: IStepsValue = {
            title: Translator.get('ptv_form_title', 'Activación exitosa'),
            subtitle: Translator.get('ptv_form_subtitle', 'Ingresa un correo electrónico'),
            placeholder: Translator.get('ptv_form_placeholder', 'Correo'),
            next: Translator.get('ptv_form_button_next', 'Siguiente'),
            cancel: Translator.get('ptv_form_button_skip', 'Omitir'),
        };
        return result[attribute] ?? '';
    };


    public componentWillUnmount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.removeEventListener('keydown', this.onFocus, true);
    }

    public componentDidMount(): void {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onFocus, true);
        if(this.props.user && this.props.user.ptv_url)
        {
            let qm= this.props.user.ptv_url.split('?');
            qm= Utils.getAllParametersFromQs(qm[1]);
            this.account = qm['account'];

        }
        if(Utils.isModalHide()){
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
        
    }

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }


    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "YELLOW":
                this.handleBack();
            break;
        }
    }

    @autobind
    private onFocus (): void  {
        Utils.onFocusElement([{ id: 'emailInput'}]);
    }

    public render(): JSX.Element {
        const { step, valid, errorFromBackend } = this.state;
        return (
            <Grid>
                <Row className={cls(`${PTV}-row`)}>
                    <Column lg={3} className={cls(`${PTV}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroTv logo" />
                    </Column>
                </Row>
                <Row className={cls(`${PTV}-row-enabled`)}>
                    <Form id="ptv-form">
                        <Column lg={6} className={cls(`${PTV}-column-keyboard`)}>
                            <Keyboard onFocus = {this.onFocus}/>
                        </Column>
                        <Column lg={6} className={cls(`${PTV}-column-inputs`)}>
                            <Row className={cls(`${PTV}-row-inputs`)}>
                                {/* ************** TITLE ****************** */}
                                <Column lg={12}>
                                    <Heading size={1} className={cls(`${PTV}-title`)}>
                                        {this.getTextBySteps('title')}
                                    </Heading>
                                </Column>

                                {/* ************** SUBTITLE ****************** */}
                                <Column lg={12}>
                                    <Heading size={2} className={cls(`${PTV}-subtitle`)}>
                                        {this.getTextBySteps('subtitle')}
                                    </Heading>
                                </Column>

                                {/* ************** INPUT AND  BUTON PASSWORD, EMAIL ****************** */}
                                <Column lg={12} className={cls(`${PTV}-column-input`)}>
                                    {step === Steps.STEP_MAIL && (
                                        <FormInput
                                            id = "emailInput"
                                            focusWhenMount
                                            type="email"
                                            name="alphanumeric"
                                            placeholder={this.getTextBySteps('placeholder')}
                                            errorFromBackend={errorFromBackend}
                                            onChange={this.handleChange}
                                            validInput={valid}
                                        />
                                    )}
                                </Column>
                                {/* ************** CANCEL BUTTON AND CONFIRM BUTTON ****************** */}
                                <Column lg={11}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        className={cls(`focusable`, `${PTV}-button-next`, this.isValidForm ? '' : 'disabled')}
                                        onClick={this.handleNextStep}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('next')}
                                    </Button>
                                </Column>
                                <Column lg={11} className={cls(`${PTV}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(`focusable`, `${PTV}-button-cancel`)}
                                        onClick={this.handleCancel}
                                        block
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getTextBySteps('cancel')}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    cleanUserPtvUrl,
    fetchAuthDeviceEmailRegistration,
};

const mapStateToProps = (state: { user: any; }) => { return {user: state.user}};

export default connect(mapStateToProps, mapDispatchToProps)(Ptv);



// WEBPACK FOOTER //
// ./src/authentication/Ptv/index.tsx